// src/api/apiAgents.js
import axios from "../utils/axios";

/// Get Agents
export const getAllAgents = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("agents", { params });
    return data;
};

/// Get Agent
export const getAgent = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`agents/${id}`);
    return data;
};

/// Create Agent
export const createAgent = async (req) => {
    try {
        const { data } = await axios.post("agents", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createAgent error:", error);
        throw error;
    }
};

/// Update Agent
export const updateAgent = async (id, req) => {
    try {
        const { data } = await axios.put(`agents/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateAgent error:", error);
        throw error;
    }
};

/// Delete Agent
export const deleteAgent = async (id) => {
    try {
        const { data } = await axios.delete(`agents/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteAgent error:", error);
        throw error;
    }
};

/// Delete All Agents
export const deleteAllAgents = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "agents/mass-destroy",
            { data: { items: ids } },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("deleteAllAgents error:", error);
        throw error;
    }
};

/// Restore Agent
export const restoreAgent = async (id) => {
    try {
        const { data } = await axios.post(`agents/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreAgent error:", error);
        throw error;
    }
};

/// Restore multiple Agents
export const restoreAllAgents = async (ids = []) => {
    try {
        const { data } = await axios.post(
            "agents/mass-restore",
            { items: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("restoreAllAgents error:", error);
        throw error;
    }
};

/// Force Delete Agent
export const forceDeleteAgent = async (id) => {
    try {
        const { data } = await axios.delete(`agents/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteAgent error:", error);
        throw error;
    }
};

/// Force Delete multiple Agents
export const forceDeleteAllAgents = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "agents/mass-force-delete",
            { data: { items: ids } },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllAgents error:", error);
        throw error;
    }
};

/// Get Agents For Select
export const getAgentsForSelect = async () => {
    try {
        const { data } = await axios.get("agents/for-select");
        return data;
    } catch (error) {
        console.error("getAgentsForSelect error:", error);
        throw error;
    }
};
